import { Cart, CartLine, OrderTypes } from '@next/core-lib/cart';
import { AllowedOrderRoles } from '@next/core-lib/models';

export const isSalesOrder = (orderType: OrderTypes): boolean =>
  orderType === OrderTypes.salesOrder ||
  orderType === OrderTypes.rushOrder ||
  orderType === OrderTypes.emergencyOrder ||
  orderType === OrderTypes.pickUpOrder ||
  orderType === OrderTypes.grainPreSalesOrder;

export const isPresalesOrder = (orderType: OrderTypes): boolean => orderType === OrderTypes.preSalesOrder;

export const createCart = (lines = [createCartLine()], type = OrderTypes.salesOrder): Cart => ({
  lines,
  type,
  validationMessages: [],
  id: 123,
});

export const createCartLine = (closingTimeUtc = '2022-01-02T11:00:00Z', showClosingTime = true): CartLine => ({
  skuId: 1,
  externalSkuId: '1',
  quantity: 42,
  orderingInformation: {
    allowedOrderTypes: [OrderTypes.salesOrder, OrderTypes.emergencyOrder],
    usable: true,
    allowedUsers: AllowedOrderRoles.advisorsAndAbove,
    flexibility: 0,
    useFixedFlexibility: false,
  },
  deliveryInformation: {
    deliveryDate: '2022-01-01T23:00:00Z',
    deliveryTimeWindow: null,
    flexibility: 0,
    periodId: null,
    deliverySalesOrderPeriod: null,
    closingTimeUtc,
    showClosingTime,
  },
  validationMessages: [],
});
